import { useState } from "react";
import modalclose from "../images/modalclose.svg";
import userForm from "../images/userForm.svg";
import lock from "../images/lock.svg";
import { Link } from "react-router-dom";
import eye from "../images/eye.svg";
import referral from "../images/referral.svg";
import { useRegisterMutation } from "../store/apis";
import {
  registrationSuccess,
  setLoginModal,
  setRegisterModal,
} from "../store/auth-slice";
import { useDispatch } from "react-redux";
import PhoneConfirmationModal from "./PhoneNumberConfirmation";

const Register = ({ isOpen, onClose }) => {
  const [register, { isLoading }] = useRegisterMutation();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    phone: "",
    password: "",
    confirmPassword: "",
    referralCode: "",
  });

  const [errors, setErrors] = useState({
    phone: "",
    password: "",
    confirmPassword: "",
    referralCode: "",
    terms: "",
    general: "",
  });
  const [isPhoneConfirmationOpen, setIsPhoneConfirmationOpen] = useState(false);
  if (!isOpen) return null;

  const validateForm = () => {
    let isValid = true;
    const newErrors = {
      phone: "",
      password: "",
      confirmPassword: "",
      referralCode: "",
      terms: "",
      general: "",
    };

    // Phone validation
    // const phoneRegex = /^[17]\d{0,8}$/;
    // if (!formData.phone) {
    //   newErrors.phone = "Phone number is required";
    //   isValid = false;
    // } else if (formData.phone.length > 9) {
    //   newErrors.phone = "Phone number must have 9 characters";
    //   isValid = false;
    // } else if (!phoneRegex.test(formData.phone)) {
    //   newErrors.phone = "Phone number must start with 7 or 1";
    //   isValid = false;
    // }
    const phoneRegex = /^(7|9|1)\d{8}$/; // Starts with 7, 9, or 1 and must be exactly 9 digits

    if (!formData.phone) {
      newErrors.phone = "Phone number is required";
      isValid = false;
    } else if (!phoneRegex.test(formData.phone)) {
      newErrors.phone =
        "Invalid  phone number (must start with 7, 9, or 1 and be 9 digits)";
      isValid = false;
    }

    // Password validation
    if (!formData.password) {
      newErrors.password = "Password is required";
      isValid = false;
    }

    // Confirm password validation
    if (!formData.confirmPassword) {
      newErrors.confirmPassword = "Please confirm your password";
      isValid = false;
    } else if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
      isValid = false;
    }

    // Terms validation
    if (!acceptedTerms) {
      newErrors.terms = "You must accept the terms and conditions";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));
    // Clear error when user starts typing
    if (errors[id]) {
      setErrors((prev) => ({
        ...prev,
        [id]: "",
      }));
    }
  };
  const openLoginModalHandler = (e) => {
    e.preventDefault();
    dispatch(setLoginModal(true));
    dispatch(setRegisterModal(false));
  };

  // Modified to open phone confirmation modal first
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    // Open phone confirmation modal instead of registering directly
    setIsPhoneConfirmationOpen(true);
  };

  // Handle registration after phone number confirmation
  const handlePhoneConfirmed = async () => {
    try {
      const response = await register({
        username: `251${formData.phone}`,
        password: formData.password,
        // referralCode: formData.referralCode || undefined,
      }).unwrap();

      // Close both modals
      setIsPhoneConfirmationOpen(false);
      dispatch(setLoginModal(true));
      dispatch(setRegisterModal(false));
      onClose();
    } catch (error) {
      setIsPhoneConfirmationOpen(false); // Close confirmation modal on error
      setErrors((prev) => ({
        ...prev,
        general:
          error.data?.message || "Registration failed. Please try again.",
      }));
    }
  };

  // Go back to registration form to edit phone number
  const handleEditPhoneNumber = () => {
    setIsPhoneConfirmationOpen(false);
  };

  return (
    <>
      <div
        className="fixed inset-0 bg-black/50 flex justify-center items-center z-50"
        role="dialog"
        aria-modal="true"
      >
        <div className="h-full w-full overflow-y-auto flex justify-center items-center pt-10 mb-5">
          <div
            className="relative w-full h-full max-w-[541px] animate-fade-in"
            tabIndex={0}
          >
            <div className="px-[15px]">
              <div className="bg-shadeGreen p-[32px_30px] rounded-[8px_8px_0px_0px] relative overflow-auto border-l-2 border-t-2 border-r-2 border-[#33494E]">
                <div className="flex justify-between items-start pb-[10px] mb-5 border-b-[1px] border-[#33494E]">
                  <div className="flex flex-col gap-3">
                    <h4 className="text-white text-2xl font-medium">
                      CREATE YOUR ACCOUNT
                    </h4>
                    <p className="text-[#8DA0A9] text-sm md:text-base font-normal">
                      Home to the best odds, instant payouts and many bonuses
                    </p>
                  </div>
                  <button
                    onClick={onClose}
                    className="w-[38px] h-[38px] min-w-[38px] flex justify-center items-center border-[1px] rounded-md border-[#33494E] bg-[rgba(0, 0, 0, 0.3)] hover:bg-[rgba(0, 0, 0, 0.5)] transition-all duration-[0.4s]"
                  >
                    <img src={modalclose} alt="close" />
                  </button>
                </div>

                <form onSubmit={handleSubmit} id="register">
                  {errors.general && (
                    <div className="mb-4 p-2 text-red-600 bg-red-100/20 rounded border border-red-600">
                      {errors.general}
                    </div>
                  )}

                  <div className="space-y-6">
                    {/* Phone Number Input */}
                    <div className="flex flex-col">
                      <label
                        htmlFor="phone"
                        className="text-base font-normal text-[#8DA0A9] mb-2"
                      >
                        Phone number*
                      </label>
                      <div className="relative flex">
                        <div className="bg-[#061015] border border-[#33494E] text-[#8DA0A9] h-[48px] px-4 flex items-center justify-center rounded-l-md">
                          +251
                        </div>
                        <input
                          type="text"
                          id="phone"
                          value={formData.phone}
                          onChange={handleInputChange}
                          placeholder="7xxxxxxxx"
                          className="block w-full h-[48px] px-4 bg-[#061015] border border-[#33494E] rounded-r-md focus:outline-none focus:border-[#4A9BA5] text-base font-normal text-[#E9EDEF] placeholder:text-[#515D63]"
                        />
                      </div>
                      {errors.phone && (
                        <p className="mt-1 text-red-500 text-sm">
                          {errors.phone}
                        </p>
                      )}
                    </div>

                    {/* Password Input */}
                    <div className="flex flex-col">
                      <label
                        htmlFor="password"
                        className="text-base font-normal text-[#8DA0A9] mb-2"
                      >
                        Password*
                      </label>
                      <div className="relative">
                        <input
                          type={showPassword ? "text" : "password"}
                          value={formData.password}
                          onChange={handleInputChange}
                          id="password"
                          placeholder="Enter Password"
                          className={`block w-full h-[48px] px-4 bg-[#061015] border ${
                            errors.password
                              ? "border-red-500"
                              : "border-[#33494E]"
                          } rounded-md focus:outline-none focus:border-[#4A9BA5] text-base font-normal text-[#E9EDEF] placeholder:text-[#515D63]`}
                        />
                        <button
                          type="button"
                          onClick={() => setShowPassword(!showPassword)}
                          className="absolute top-1/2 -translate-y-1/2 right-[10px] w-[24px] h-[24px] flex items-center justify-center text-[#8DA0A9]"
                          tabIndex={-1}
                        >
                          <img
                            src={eye}
                            alt="toggle password visibility"
                            className="object-contain w-5"
                          />
                        </button>
                      </div>
                      {errors.password && (
                        <p className="mt-1 text-red-500 text-sm">
                          {errors.password}
                        </p>
                      )}
                    </div>

                    {/* Confirm Password Input */}
                    <div className="flex flex-col">
                      <label
                        htmlFor="confirmPassword"
                        className="text-base font-normal text-[#8DA0A9] mb-2"
                      >
                        Confirm Password*
                      </label>
                      <div className="relative">
                        <input
                          type={showConfirmPassword ? "text" : "password"}
                          value={formData.confirmPassword}
                          onChange={handleInputChange}
                          id="confirmPassword"
                          placeholder="Confirm Password"
                          className={`block w-full h-[48px] px-4 bg-[#061015] border ${
                            errors.confirmPassword
                              ? "border-red-500"
                              : "border-[#33494E]"
                          } rounded-md focus:outline-none focus:border-[#4A9BA5] text-base font-normal text-[#E9EDEF] placeholder:text-[#515D63]`}
                        />
                        <button
                          type="button"
                          onClick={() =>
                            setShowConfirmPassword(!showConfirmPassword)
                          }
                          className="absolute top-1/2 -translate-y-1/2 right-[10px] w-[24px] h-[24px] flex items-center justify-center text-[#8DA0A9]"
                          tabIndex={-1}
                        >
                          <img
                            src={eye}
                            alt="toggle password visibility"
                            className="object-contain w-5"
                          />
                        </button>
                      </div>
                      {errors.confirmPassword && (
                        <p className="mt-1 text-red-500 text-sm">
                          {errors.confirmPassword}
                        </p>
                      )}
                    </div>

                    {/* Referral Code Input */}
                    <div className="flex flex-col">
                      <label
                        htmlFor="referralCode"
                        className="text-base font-normal text-[#8DA0A9] mb-2"
                      >
                        Promo code (If you have one)
                      </label>
                      <div className="relative">
                        <input
                          type="text"
                          id="referralCode"
                          value={formData.referralCode}
                          onChange={handleInputChange}
                          placeholder="Enter promo code"
                          className="block w-full h-[48px] px-4 bg-[#061015] border border-[#33494E] rounded-md focus:outline-none focus:border-[#4A9BA5] text-base font-normal text-[#E9EDEF] placeholder:text-[#515D63]"
                        />
                      </div>
                      {errors.referralCode && (
                        <p className="mt-1 text-red-500 text-sm">
                          {errors.referralCode}
                        </p>
                      )}
                    </div>

                    {/* Terms agreement */}
                    <div className="flex items-center gap-2">
                      <div className="relative flex items-center">
                        <input
                          type="checkbox"
                          id="terms"
                          checked={acceptedTerms}
                          onChange={(e) => setAcceptedTerms(e.target.checked)}
                          className="w-6 h-6 opacity-0 absolute"
                        />
                        <div
                          className={`h-6 w-6 border ${
                            acceptedTerms
                              ? "bg-[#4A9BA5]/30 border-[#4A9BA5]"
                              : "bg-[#061015] border-[#33494E]"
                          } rounded-sm flex items-center justify-center`}
                        >
                          {acceptedTerms && (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-4 w-4 text-[#4A9BA5]"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M5 13l4 4L19 7"
                              />
                            </svg>
                          )}
                        </div>
                      </div>
                      <label className="text-[#8DA0A9] text-sm">
                        By clicking button below, you agree to our{" "}
                        <Link to="/" className="text-[#4A9BA5]">
                          Rules
                        </Link>
                      </label>
                    </div>
                    {errors.terms && (
                      <p className="mt-1 text-red-500 text-sm">
                        {errors.terms}
                      </p>
                    )}

                    {/* Buttons */}
                    <div className="flex flex-col gap-4">
                      <button
                        type="submit"
                        disabled={isLoading}
                        className="w-full bg-yellow hover:bg-[#3D8089] py-4 text-white font-medium rounded-md transition-all duration-300"
                      >
                        {isLoading ? "REGISTERING..." : "REGISTER"}
                      </button>
                      <button
                        onClick={openLoginModalHandler}
                        type="button"
                        className="w-full bg-buttonGradient bg-no-repeat text-white hover:text-white hover:border-[#1b4334] hover:bg-buttonGradientHover py-4 font-medium rounded-md transition-all duration-300"
                      >
                        LOGIN
                      </button>
                    </div>
                  </div>
                </form>
              </div>

              {/* Disclaimer */}
              <div className="bg-[#061015] text-[#8DA0A9] text-sm text-center py-3 rounded-[0px_0px_8px_8px] border-l-2 border-r-2 border-b-2 border-[#33494E] border-t-0">
                You must be 18 yrs and above in order to sign up.
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Phone Confirmation Modal */}
      <PhoneConfirmationModal
        isOpen={isPhoneConfirmationOpen}
        onClose={() => setIsPhoneConfirmationOpen(false)}
        phoneNumber={formData.phone}
        onConfirm={handlePhoneConfirmed}
        onEdit={handleEditPhoneNumber}
      />
    </>
  );
};

export default Register;
